import { z } from 'zod';
export * from './domain/game.js';
export * from './access.js';
export * from './game-view.js';
export * from './action-brief.js';
export * from './manual-round.js';
export * from './organization.js';
export * from './resources.js';
export * from './closing.js';
export const errorResponseSchema = z.object({
    code: z.string(),
    message: z.string(),
    correlationId: z.string(),
});
export * from './review.js';
export * from './formation.js';
export * from './board.js';
//# sourceMappingURL=index.js.map